import { render, staticRenderFns } from "./ServiceinvoiceView.vue?vue&type=template&id=92c69f72"
import script from "./ServiceinvoiceView.vue?vue&type=script&lang=js"
export * from "./ServiceinvoiceView.vue?vue&type=script&lang=js"
import style0 from "./ServiceinvoiceView.vue?vue&type=style&index=0&id=92c69f72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports